module.exports = __webpack_public_path__ + "media/slot-game/coupon-100-f5dd49d6.svg";